import React, { useState } from "react";
import "./QRA.css";
import { submitProductEnquiry } from "../../api";
import toast, { Toaster } from "react-hot-toast";
import Attendancehero from "../../Asset/QRA Hero.png"

// ================= HEADER =================
function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="tms-header">
      <div className="tms-logo-area">
        <div className="tms-logo-box">Y</div>
        <div>
          <h2>Yashvitech</h2>
          <p>QR ATTENDANCE SYSTEM</p>
        </div>
      </div>

      <nav className={`tms-nav-menu ${menuOpen ? "tms-active" : ""}`}>
        <a href="#features" onClick={closeMenu}>Key Features</a>
        <a href="#demo" onClick={closeMenu}>Interactive Demo</a>
        <a href="#stories" onClick={closeMenu}>Success Stories</a>
        <a href="#faq" onClick={closeMenu}>FAQ</a>
        <div className="tms-mobile-cta">
          <div className="tms-phone">☎ <span>+91 98765 43210</span></div>
          <a href="#Book" className="tms-demo-btn" onClick={closeMenu}>Book Free Demo</a>
        </div>
      </nav>

      <div className="tms-header-right">
        <div className="tms-phone">☎ <span>+91 98765 43210</span></div>
        <a href="#Book" className="tms-demo-btn">Book Free Demo</a>
      </div>

      <button className={`tms-menu-toggle ${menuOpen ? "tms-toggle-active" : ""}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
        <span className="tms-bar"></span><span className="tms-bar"></span><span className="tms-bar"></span>
      </button>
    </header>
  );
}

// ================= HOME =================
function Home() {
  return (
    <section id="home" className="tms-home">
      <div className="tms-home-left">
        <div className="tms-badge">📱 #1 QR-Based Attendance & HR Software in India</div>
        <h1>Automate Attendance,<br />Eliminate Proxy & Boost<br />Productivity with<span> Yashvitech QRAS</span></h1>
        <p>A powerful cloud-based QR Attendance System designed for offices, factories, schools and enterprises of all sizes.</p>
        <div className="tms-home-buttons">
          <button>Book Free Demo →</button>
          <button>Explore Features</button>
        </div>
      </div>
      <div className="tms-home-right">
        <img src={Attendancehero} alt="QR Attendance System" />
      </div>
    </section>
  );
}

// ================= STATS =================
function Stats() {
  return (
    <section className="tms-stats">
      <div><h2>500+</h2><p>Companies Onboarded</p></div>
      <div><h2>1M+</h2><p>Daily Scans</p></div>
      <div><h2>99.9%</h2><p>Accuracy</p></div>
    </section>
  );
}

// ================= TRUSTED =================
function Trusted() {
  return (
    <section className="tms-trusted">
      <p>TRUSTED BY 500+ CORPORATE OFFICES, FACTORIES, INSTITUTES & GROWING BUSINESSES</p>
      <div className="tms-companies">
        <h3>▣ Apex Corporate Solutions</h3>
        <h3>▰ SkyHigh IT Services</h3>
        <h3>▤ Global EduTech Institute</h3>
        <h3>▥ National Manufacturing Co.</h3>
        <h3>♧ Royal Business Group</h3>
      </div>
    </section>
  );
}

// ================= INTERACTIVE DEMO =================
function InteractiveDemo() {
  const [showBilty, setShowBilty] = useState(false);

  return (
    <section className="tms-demo-section" id="demo">
      <span className="tms-demo-section-tag">LIVE QRAS EXPERIENCE</span>
      <h1>Experience Yashvitech QRAS in Action</h1>
      <p className="tms-demo-description">Explore our HR attendance dashboard and see how everyday workforce management can be handled from one smart platform.</p>

      <div className="tms-demo-mini-stats">
        <div><strong>500+</strong><span>Active Companies</span></div>
        <div><strong>1M+</strong><span>Daily Scans</span></div>
        <div><strong>99.9%</strong><span>System Uptime</span></div>
        <div><strong>24/7</strong><span>Support</span></div>
      </div>

      <div className="tms-demo-tabs">
        <button className={showBilty ? "tms-active-tab" : ""} onClick={() => setShowBilty(!showBilty)}>📱 Attendance Log</button>
        <button>👥 Employee Dashboard</button>
        <button>🏖 Leave Management</button>
        <button>📊 Payroll Report</button>
      </div>

      {!showBilty && (
        <div className="tms-demo-placeholder">
          <div className="tms-placeholder-icon">📱</div>
          <h3>Your Workforce, One Smart Dashboard</h3>
          <p>Scan QR codes, track live attendance, manage leaves, calculate salaries and monitor employee productivity from one place.</p>
          <button className="tms-placeholder-btn" onClick={() => setShowBilty(true)}>Open Attendance Log →</button>
        </div>
      )}

      {showBilty && (
        <div className="tms-demo-panel">
          <div className="tms-bilty-header">
            <div>
              <span className="tms-bilty-label">DAILY ATTENDANCE RECORD</span>
              <h3>Attendance Sheet #ATT-2026-8902</h3>
              <p>Company: Yashvitech Technologies Pvt. Ltd. | Date: 19-Aug-2026</p>
            </div>
            <div className="tms-bilty-status">● Present</div>
          </div>

          <div className="tms-shipment-overview">
            <div className="tms-overview-box"><span>👥</span><div><small>TOTAL EMPLOYEES</small><strong>245 Staff</strong></div></div>
            <div className="tms-overview-box"><span>✓</span><div><small>PRESENT TODAY</small><strong>231 Members</strong></div></div>
            <div className="tms-overview-box"><span>⏱</span><div><small>WORKING HOURS</small><strong>08h 45m</strong></div></div>
            <div className="tms-overview-box"><span>📱</span><div><small>SCAN STATUS</small><strong>Verified ✓</strong></div></div>
          </div>

          <div className="tms-route-box">
            <div className="tms-route-location"><small>CHECK-IN LOCATION</small><h4>Head Office, Pune</h4><p>09:02 AM • On Time</p></div>
            <div className="tms-route-line"><span>📱</span><div></div><span>📍</span></div>
            <div className="tms-route-location"><small>CHECK-OUT LOCATION</small><h4>Head Office, Pune</h4><p>05:47 PM • Completed</p></div>
          </div>

          <div className="tms-info-row">
            <div className="tms-info-card">
              <span className="tms-card-icon">👤</span>
              <h4>Employee Info</h4>
              <p><strong>Ramesh Kumar Sharma</strong></p>
              <p>ID: EMP-2026-0089</p>
              <p>Department: Software Dev</p>
              <p>Contact: +91 98765 11223</p>
            </div>
            <div className="tms-info-card">
              <span className="tms-card-icon">🏢</span>
              <h4>Branch Details</h4>
              <p><strong>Yashvitech HQ Pune</strong></p>
              <p>Branch Code: PN-01</p>
              <p>Location: Hinjewadi, Pune</p>
              <p>Manager: Suresh Patil</p>
            </div>
            <div className="tms-info-card">
              <span className="tms-card-icon">📱</span>
              <h4>Device & Scan Info</h4>
              <p>Device: <strong>Mobile (Android)</strong></p>
              <p>IP: 192.168.1.45</p>
              <p>GPS: Verified ✓</p>
              <p>Anti-Proxy: Passed ✓</p>
            </div>
          </div>

          <div className="tms-bilty-details">
            <div><small>ATTENDANCE ID</small><strong>ATT-2026-8902</strong></div>
            <div><small>EMPLOYEE CODE</small><strong>EMP-2026-0089</strong></div>
            <div><small>SHIFT</small><strong>General (9-6)</strong></div>
            <div><small>STATUS</small><strong className="tms-paid">● Present</strong></div>
          </div>

          <div className="tms-table-heading">
            <div><h4>Today's Activity Log</h4><p>Scan history, breaks and total working hours</p></div>
            <span>2 Entries</span>
          </div>

          <table className="tms-demo-table">
            <thead><tr><th>Activity Type</th><th>Time</th><th>Location</th><th>Status</th></tr></thead>
            <tbody>
              <tr><td><strong>Check-In (Morning Scan)</strong><small>QR + GPS Verified</small></td><td>09:02 AM</td><td>Main Gate</td><td><strong>✓ On Time</strong></td></tr>
              <tr><td><strong>Check-Out (Evening Scan)</strong><small>QR + GPS Verified</small></td><td>05:47 PM</td><td>Main Gate</td><td><strong>✓ Completed</strong></td></tr>
            </tbody>
          </table>

          <div className="tms-financial-section">
            <div className="tms-financial-card"><small>DAYS PRESENT</small><h2>22 Days</h2><p>Out of 24 Working Days</p></div>
            <div className="tms-financial-card"><small>LEAVES TAKEN</small><h2>02 Days</h2><p>Casual Leave</p></div>
            <div className="tms-financial-card"><small>OVERTIME HOURS</small><h2>12h 30m</h2><p>Extra hours this month</p></div>
          </div>

          <div className="tms-bill-summary">
            <div className="tms-summary-note">
              <span>✓</span>
              <div><strong>Attendance Verified & Approved</strong><p>All scans have been validated with GPS and anti-proxy checks.</p></div>
            </div>
            <div className="tms-summary-total">
              <div><span>Working Hours</span><strong>08h 15m</strong></div>
              <div><span>Overtime</span><strong>00h 30m</strong></div>
              <hr />
              <div className="tms-grand-total"><span>Total Duration</span><strong>08h 45m</strong></div>
            </div>
          </div>

          <div className="tms-delivery-timeline">
            <h4>Today's Activity Timeline</h4>
            <div className="tms-timeline">
              <div className="tms-timeline-item tms-completed"><span>✓</span><div><strong>Check-In Scanned</strong><p>19 Aug 2026 · 09:02 AM</p></div></div>
              <div className="tms-timeline-item tms-completed"><span>✓</span><div><strong>Lunch Break</strong><p>19 Aug 2026 · 01:00 PM to 01:30 PM</p></div></div>
              <div className="tms-timeline-item tms-active"><span>●</span><div><strong>Currently Working</strong><p>Live Status · Desk Active</p></div></div>
              <div className="tms-timeline-item"><span>○</span><div><strong>Check-Out Expected</strong><p>Expected · 06:00 PM</p></div></div>
            </div>
          </div>

          <div className="tms-document-row">
            <div className="tms-document-box"><span>📄</span><div><strong>Attendance Report</strong><p>ATT-2026-8902.pdf</p></div><button>View</button></div>
            <div className="tms-document-box"><span>✓</span><div><strong>Verification Log</strong><p>QR · GPS · Device Verified</p></div><button>View</button></div>
          </div>

          <div className="tms-panel-actions">
            <button className="tms-btn-dark">🖨 Print Attendance PDF</button>
            <button className="tms-btn-whatsapp">💬 Send WhatsApp to HR</button>
            <button className="tms-btn-dark">📤 Share Report</button>
          </div>
        </div>
      )}
    </section>
  );
}

// ================= SUCCESS STORIES =================
function SuccessStories() {
  const reviews = [
    { text: "Earlier, our HR team spent 3 days every month just calculating attendance and salaries. Yashvitech QRAS automated our entire process. Proxy attendance issues are now completely eliminated with GPS locking.", name: "Rajesh Patel", role: "HR Director, Gujarat IT Solutions", company: "450+ Employees", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=500&q=80", result: "Faster Payroll & Zero Proxy", number: "70%", label: "Faster HR Operations" },
    { text: "The real-time dashboard is a game-changer. I can instantly see which employee is present, on leave or late. Payroll integration saved us thousands of hours in manual calculations.", name: "Suresh Khatri", role: "CEO, SkyHigh Manufacturing", company: "800+ Workers", image: "https://images.unsplash.com/photo-1560250097-0b93528c3070?auto=format&fit=crop&w=500&q=80", result: "Better Workforce Control", number: "25%", label: "Productivity Increased" },
    { text: "Excellent support team from Yashvitech. They migrated all our old attendance data seamlessly. The mobile app works smoothly so our field staff can mark attendance from anywhere with GPS verification.", name: "Anil Sharma", role: "Admin Head, Apex Corporate Group", company: "Multi-Branch Setup", image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?auto=format&fit=crop&w=500&q=80", result: "Easy Multi-Branch Handling", number: "3x", label: "Faster Attendance Marking" },
  ];

  return (
    <section className="tms-success-section" id="stories">
      <div className="tms-success-top">
        <span className="tms-success-badge">★ CLIENT SUCCESS STORIES</span>
        <h1>Trusted by HR Teams.<br /><span>Loved by Business Owners.</span></h1>
        <p className="tms-success-description">From growing startups to large enterprises, Yashvitech QRAS helps organizations simplify HR operations, control workforce and increase productivity.</p>
      </div>

      <div className="tms-success-highlights">
        <div className="tms-success-highlight"><strong>500+</strong><span>Companies</span></div>
        <div className="tms-success-highlight"><strong>1M+</strong><span>Daily Scans</span></div>
        <div className="tms-success-highlight"><strong>4.9/5</strong><span>Customer Rating</span></div>
        <div className="tms-success-highlight"><strong>99.9%</strong><span>System Uptime</span></div>
      </div>

      <div className="tms-review-heading">
        <span className="tms-review-label">REAL CUSTOMERS • REAL RESULTS</span>
        <h2>See the Impact of Yashvitech QRAS</h2>
        <p>Businesses are saving time, reducing HR leakage and making smarter workforce decisions every day.</p>
      </div>

      <div className="tms-success-cards">
        {reviews.map((review, index) => (
          <div className="tms-success-card" key={index}>
            <div className="tms-success-card-top">
              <div className="tms-stars">★★★★★</div>
              <span className="tms-verified-review">✓ Verified Customer</span>
            </div>
            <p className="tms-review-text">"{review.text}"</p>
            <div className="tms-review-result">
              <span className="tms-impact-label">BUSINESS IMPACT</span>
              <strong>{review.result}</strong>
            </div>
            <div className="tms-review-performance">
              <div><strong>{review.number}</strong><span>{review.label}</span></div>
              <span className="tms-performance-icon">↗</span>
            </div>
            <div className="tms-review-person">
              <div className="tms-review-image"><img src={review.image} alt={review.name} /></div>
              <div className="tms-review-person-info">
                <h4>{review.name}</h4>
                <p>{review.role}</p>
                <span>👥 {review.company}</span>
              </div>
              <div className="tms-customer-check">✓</div>
            </div>
          </div>
        ))}
      </div>

      <div className="tms-success-trust">
        <span>✓ Secure Cloud Platform</span><span>✓ Dedicated Support</span><span>✓ Easy Data Migration</span><span>✓ Mobile Friendly</span>
      </div>

      <div className="tms-success-bottom">
        <div className="tms-success-bottom-content">
          <span className="tms-join-tag">JOIN 500+ SMART BUSINESSES</span>
          <h2>Ready to automate your<br />HR & attendance process?</h2>
          <p>Discover how Yashvitech QRAS can simplify your attendance, leaves, payroll and workforce management.</p>
        </div>
        <a href="#Book" className="tms-success-demo-btn">Book Free Demo <span>→</span></a>
      </div>
    </section>
  );
}

// ================= FAQ =================
function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (index) => setOpenIndex(openIndex === index ? null : index);

  const questions = [
    { q: "What is a QR Attendance System (QRAS)?", a: "QRAS is a cloud-based platform that lets employees mark their attendance by scanning a dynamic QR code with their phone. It automates check-in, check-out, leave and payroll in one place." },
    { q: "How does Yashvitech QRAS prevent proxy attendance?", a: "Our system uses dynamic QR codes (that refresh every few seconds) combined with GPS Geo-Fencing and device locking. This makes proxy or fake attendance virtually impossible." },
    { q: "Can employees mark attendance without internet?", a: "Yes, our mobile app supports offline scanning. Data automatically syncs to the cloud once the device gets an internet connection." },
    { q: "Does QRAS integrate with Payroll and Salary software?", a: "Absolutely. Yashvitech QRAS auto-calculates working hours, overtime, and leaves, and integrates seamlessly with popular payroll systems for salary processing." },
  ];

  return (
    <section className="tms-faq-section" id="faq">
      <div className="tms-faq-top">
        <span className="tms-faq-tag">GOT QUESTIONS?</span>
        <h1>Frequently Asked Questions<span> About Yashvitech QRAS</span></h1>
        <p className="tms-faq-sub">Everything you need to know about managing your workforce attendance, leaves and payroll with Yashvitech QRAS.</p>
      </div>

      <div className="tms-faq-main">
        <div className="tms-faq-image-area">
          <div className="tms-faq-image-box">
            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=85" alt="QR Attendance Management" />
            <div className="tms-faq-image-content">
              <span>YASHVITECH QRAS</span>
              <h2>Run Your HR<br />Operations Smarter.</h2>
              <p>Manage employees, shifts, leaves, payroll and productivity from one powerful platform.</p>
            </div>
          </div>
          <div className="tms-faq-stat-card"><strong>24/7</strong><span>Live<br />Attendance</span></div>
          <div className="tms-faq-live-card">
            <span className="tms-live-dot"></span>
            <div><strong>HR Dashboard</strong><small>Live scanning active</small></div>
          </div>
        </div>

        <div className="tms-faq-content">
          <div className="tms-faq-content-title">
            <span>HR SOFTWARE FAQ</span>
            <h2>Simple answers.<br />Powerful solutions.</h2>
          </div>

          <div className="tms-faq-list">
            {questions.map((item, index) => (
              <div className={`tms-faq-item ${openIndex === index ? "tms-faq-active" : ""}`} key={index}>
                <div className="tms-faq-question" onClick={() => toggle(index)}>
                  <span className="tms-faq-number">0{index + 1}</span>
                  <h3>{item.q}</h3>
                  <span className="tms-faq-icon">{openIndex === index ? "−" : "+"}</span>
                </div>
                {openIndex === index && <p className="tms-faq-answer">{item.a}</p>}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="tms-faq-features">
        <div className="tms-faq-feature-card"><span className="tms-faq-feature-icon">📱</span><div><h3>Smart Attendance</h3><p>Contactless QR scanning with GPS verification for accurate tracking.</p></div></div>
        <div className="tms-faq-feature-card"><span className="tms-faq-feature-icon">💰</span><div><h3>Payroll Management</h3><p>Auto-calculate salaries, overtime, deductions and leaves in one click.</p></div></div>
        <div className="tms-faq-feature-card"><span className="tms-faq-feature-icon">📊</span><div><h3>HR Analytics</h3><p>Get clear insights on productivity, absenteeism and workforce trends.</p></div></div>
      </div>

      <div className="tms-faq-bottom">
        <div>
          <span>NEED MORE INFORMATION?</span>
          <h2>Ready to simplify your<br />HR operations?</h2>
          <p>See how Yashvitech QRAS can help you manage your complete workforce from one place.</p>
        </div>
        <button onClick={() => document.getElementById("demo")?.scrollIntoView({ behavior: "smooth" })}>Explore QRAS <span>→</span></button>
      </div>
    </section>
  );
}

// ================= DEMO FORM =================
function DemoForm() {
  const [formData, setFormData] = useState({
    name: "", company: "", phone: "", email: "",
    teamSize: "1 to 25 Employees", challenge: "Stopping Proxy Attendance",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleDemoSubmit = async (e) => {
    e.preventDefault();

    // Validation — email ya phone mein se ek zaroori
    if (!formData.email.trim() && !formData.phone.trim()) {
      toast.error("Please enter either Email or Phone number.");
      return;
    }

    setLoading(true);
    try {
      const result = await submitProductEnquiry({
        name: formData.name,
        email: formData.email || "",
        phone: formData.phone,
        company: formData.company,
        product: "QRAS",
        message: `Team Size: ${formData.teamSize} | Challenge: ${formData.challenge}`,
      });

      if (result.status === "success") {
        // ✅ Toast with name
        toast.success(
          `Congratulations ${formData.name}! Your form is submitted successfully. We will respond to you as soon as possible.`,
          { duration: 5000 }
        );
        setFormData({ name: "", company: "", phone: "", email: "", teamSize: "1 to 25 Employees", challenge: "Stopping Proxy Attendance" });
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="tms-demo-form-section" id="Book">
      <div className="tms-demo-left">
        <span className="tms-demo-tag">FREE PERSONALIZED DEMO</span>
        <h1>Ready to Automate Attendance & Boost Employee Productivity?</h1>
        <p>Schedule a 15-minute live demo with our QR Attendance System specialists. We will show you how Yashvitech QRAS can fit your exact team size and business workflow.</p>
        <p>✔ Zero Setup Fee & Custom Onboarding Assistance</p>
        <p>✔ Instant Data Import from Excel / Biometric Systems</p>
        <p>✔ Dedicated Account Manager & 24/7 Support</p>
        <p>Prefer to speak directly with us?</p>
        <h3>Call Sales: +91 98765 43210</h3>
      </div>

      <div className="tms-demo-right">
        <h2>Request Your Free QRAS Demo</h2>
        <p>Fill in your details below. Our team will contact you within 15 minutes.</p>

        <form onSubmit={handleDemoSubmit}>
          <label>Full Name *</label>
          <input type="text" name="name" placeholder="e.g. Ramesh Shah" required value={formData.name} onChange={handleChange} />

          <label>Company / Organization Name *</label>
          <input type="text" name="company" placeholder="e.g. Shah Enterprises" required value={formData.company} onChange={handleChange} />

          <label>Phone Number (WhatsApp)</label>
          <input type="text" name="phone" placeholder="+91 98765 43210" value={formData.phone} onChange={handleChange} />

          <label>Business Email</label>
          <input type="email" name="email" placeholder="ramesh@shahent.com" value={formData.email} onChange={handleChange} />

          <label>Team Size (Number of Employees)</label>
          <select name="teamSize" value={formData.teamSize} onChange={handleChange}>
            <option>1 to 25 Employees</option>
            <option>26 to 100 Employees</option>
            <option>101 to 500 Employees</option>
            <option>500+ Employees</option>
          </select>

          <label>Primary Challenge</label>
          <select name="challenge" value={formData.challenge} onChange={handleChange}>
            <option>Stopping Proxy Attendance</option>
            <option>Automating Payroll</option>
            <option>Managing Multiple Branches</option>
            <option>Leave & Shift Management</option>
          </select>

          <button type="submit" className="tms-submit-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit & Book My Demo →"}
          </button>
        </form>

        <p className="tms-privacy-text">🔒 We respect your privacy. No spam guaranteed.</p>
      </div>
    </section>
  );
}

// ================= FOOTER =================
function Footer() {
  return (
    <footer className="tms-footer-section">
      <div className="tms-footer-columns">
        <div className="tms-footer-about">
          <div className="tms-footer-logo">
            <div className="tms-logo-box">Y</div>
            <h2>Yashvitech</h2>
          </div>
          <p>Yashvitech is a pioneer in web-based HR management solutions, empowering offices, factories, and educational institutes across India with cutting-edge cloud automation.</p>
          <div className="tms-footer-socials"><span>🌐</span><span>in</span><span>f</span></div>
        </div>

        <div className="tms-footer-links">
          <h3>QRAS Modules</h3>
          <p>QR Code Generator</p>
          <p>Live Attendance Tracker</p>
          <p>Leave & Holiday Log</p>
          <p>Shift & Roaster Planner</p>
          <p>Payroll Integration</p>
        </div>

        <div className="tms-footer-links">
          <h3>Reports & HR Tools</h3>
          <p>Employee Attendance Log</p>
          <p>Monthly Salary Report</p>
          <p>Overtime & Late Report</p>
          <p>Employee Directory</p>
          <p>Department Analytics</p>
        </div>

        <div className="tms-footer-contact">
          <h3>Contact Yashvitech</h3>
          <p>📍 Yashvitech Tech Park, HR Wing, India</p>
          <p>✉ info@yashvitech.com</p>
          <p>🌐 www.yashvitech.com</p>
        </div>
      </div>

      <hr />

      <div className="tms-footer-bottom">
        <p>© 2026 Yashvitech Technologies. All rights reserved. QR Attendance System (QRAS).</p>
        <div className="tms-footer-bottom-links">
          <span>Privacy Policy</span><span>Terms of Service</span><span>Security</span>
        </div>
      </div>
    </footer>
  );
}

// ================= MAIN APP =================
function App() {
  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{ duration: 5000, style: { fontSize: "13px", borderRadius: "10px", maxWidth: "380px" } }}
      />
      <Header />
      <Home />
      <Stats />
      <Trusted />
      <InteractiveDemo />
      <SuccessStories />
      <Faq />
      <DemoForm />
      <Footer />
    </>
  );
}

export default App;